module.exports = __webpack_public_path__ + "media/home3-center.4c9c6c7f.mp4";